// 挂在路由之上：上传完成后刷新 demo 列表；有上传进行中时离开页面先提示。
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, type ReactNode } from "react";
import { qk } from "@/lib/api/endpoints";
import { hasActiveUploads, setOnSettled } from "./store";

export function UploadProvider({ children }: { children: ReactNode }) {
  const qc = useQueryClient();
  useEffect(() => {
    setOnSettled(() => qc.invalidateQueries({ queryKey: qk.demosAll }));
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasActiveUploads()) e.preventDefault();
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      setOnSettled(null);
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [qc]);
  return <>{children}</>;
}
